import { ActionTypes } from '../constants/index';

export const eventReportDetails = (payload: any) => ({
  type: ActionTypes.EVENT_REPORT_DETAIL_LIST_REQUEST,
  payload,
});
